<template>
  <modal
    key="estoque-ajuste-inventario"
    id="modalSuprimentoEstoqueAjusteInventario"
    titulo="SUPRIMENTOS_ESTOQUE.AJUSTE_INVENTARIO"
    :exibir="exibir"
    :campos="$refs"
    @fechar="fecharModal"
  >
    <form-ajuste-inventario :opcoes="opcoes" :form="form" @refs="getRefs" />
    <template #modal-footer>
      <div class="d-flex justify-content-between w-100">
        <b-button variant="secondary" @click="fecharModal">
          {{ $t('GERAL.FECHAR') }}
        </b-button>
        <b-button
          variant="primary"
          @click="confirmarAjuste"
          :disabled="form.quantidadeContada === null || form.quantidadeContada === ''"
        >
          {{ $t('SUPRIMENTOS_ESTOQUE.CONFIRMAR_AJUSTE_INVENTARIO') }}
        </b-button>
      </div>
    </template>
  </modal>
</template>

<script>
// Utils & Aux:
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';
import helpers from '@/common/utils/helpers';

// Service:
import EstoqueService from '@/common/services/estoque/estoque.service';

// Components:
import FormAjusteInventario from './Form.vue';
import Modal from '@/components/modal/Modal';

// Data local no formato AAAA-MM-DD (toISOString usaria UTC e poderia virar o dia seguinte à noite).
const hoje = () => {
  const data = new Date();
  const mes = String(data.getMonth() + 1).padStart(2, '0');
  const dia = String(data.getDate()).padStart(2, '0');
  return `${data.getFullYear()}-${mes}-${dia}`;
};

const formularioVazio = () => ({
  depositoId: '',
  produtoId: '',
  quantidadeSistema: null,
  quantidadeContada: null,
  valorUnitario: null,
  dataMovimento: hoje(),
  motivo: '',
});

export default {
  props: {
    exibir: { type: Boolean, default: false },
    opcoes: { type: Object },
  },
  components: {
    Modal,
    FormAjusteInventario,
  },
  data() {
    return {
      refs: [],
      form: formularioVazio(),
    };
  },
  methods: {
    getRefs(refs) {
      this.refs = refs;
    },
    validarFormulario() {
      return helpers.validarFormulario(this.refs);
    },
    confirmarAjuste() {
      if (!this.validarFormulario()) return;

      if (Number(this.form.quantidadeContada) === Number(this.form.quantidadeSistema || 0)) {
        mensagem.warning(
          this.$t('GERAL.AVISO'),
          this.$t('SUPRIMENTOS_ESTOQUE.AJUSTE_INVENTARIO_SEM_DIFERENCA')
        );
        return;
      }

      this.$store.dispatch(START_LOADING);
      EstoqueService.ajusteInventario({
        depositoId: this.form.depositoId,
        produtoId: this.form.produtoId,
        quantidadeContada: Number(this.form.quantidadeContada),
        dataMovimento: this.form.dataMovimento,
        motivo: this.form.motivo,
        valorUnitario: this.form.valorUnitario ? Number(this.form.valorUnitario) : null,
      })
        .then(() => {
          mensagem.sucesso(
            this.$t('GERAL.SUCESSO'),
            this.$t('SUPRIMENTOS_ESTOQUE.AJUSTE_INVENTARIO_SUCESSO')
          );
          this.limpaModal();
          this.$emit('ajusteInventarioConcluido');
          this.fecharModal();
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    limpaModal() {
      setTimeout(() => {
        this.form = formularioVazio();
      }, 300);
    },
    fecharModal() {
      this.$emit('fechar');
      this.limpaModal();
    },
  },
};
</script>
